import { queryGraphQL } from 'common/util/query';
import { node, nodeWithArgs, toQuery } from 'common/util/queryHelper';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';
import { ACTIONS } from 'workflow/constants/sentBoxV4';
import newInboxActions from './newInbox';

const fetchSentTasksByStatus = (status, sortOrder, queryText, filters, limit, offset) => async dispatch => {
    dispatch(setSentTasksFetching(true));

    const query = toQuery(
        nodeWithArgs('sentTasksAndSignatureRequestsV4', { status, sortOrder, queryText, filters, limit, offset }, ['totalCount', 'binderAndStudyNames',
            node('signatureAndSDFAV4', [
                'id',
                'status',
                'title',
                'actionName',
                'type',
                'typeName',
                'sentDate',
                'dueDate',
                'sentBy',
                'taskId',
                node('requestedFrom', [
                    'displayName',
                    'id',
                    'sub',
                ]),
                'statement',
                'binderId',
                'binderName',
                'completedDate',
                node('recipients', [
                    'displayName',
                    'id',
                    'sub',
                ]),
                node('tasks', [
                    'finished',
                    'deleted',
                    'assignee',
                    'taskDefinitionKey',
                    'name',
                    'id'
                ]),
                node('document', [
                    'institutionId',
                    node('documentType', [
                        'displayName',
                    ])
                ]),
                node('delegation', [
                    'id',
                    node('user', [
                        'id',
                        'displayName',
                        'emailAddress',
                    ]),
                    node('rolesManagement', [
                        'id',
                        'name'
                    ]),
                    'taskIds',
                    'startDate',
                    'endDate',
                ]),
                node('event', [
                    'id',
                    'eventType',
                    'binderId',
                    'institutionId',
                ]),
                'previousTask',
                'nextTask'
            ])
        ]),
    );

    try {
        const response = await queryGraphQL(query);
        let returnedTasks = [], sentTasksCount, sentTasksStudyBinderNames = [];
        if (response.data.sentTasksAndSignatureRequestsV4.signatureAndSDFAV4) {
            sentTasksStudyBinderNames = response.data.sentTasksAndSignatureRequestsV4.binderAndStudyNames;
            sentTasksCount = response.data.sentTasksAndSignatureRequestsV4.totalCount;
            returnedTasks = response.data.sentTasksAndSignatureRequestsV4.signatureAndSDFAV4.filter(task => task !== null);
        }

        if (response.errors) {
            dispatch(
                addApplicationMessages(
                    'error',
                    ['Error retrieving some task records'],
                ),
            );
        }

        dispatch(setSentTasks(returnedTasks.map((s) => ({ ...s, sentFrom: s.binderName }))));
        dispatch(newInboxActions.setTasks(returnedTasks.map((s) => ({ ...s, sentFrom: s.binderName }))));
        dispatch(setSentTasksCount(sentTasksCount));
        dispatch(newInboxActions.setTasksCount(sentTasksCount));
        dispatch(setSentTasksStudyBinderNames(sentTasksStudyBinderNames));
    } catch (error) {
        dispatch(setSentTasks([]));
        dispatch(setSentTasksCount(''));
        dispatch(setSentTasksStudyBinderNames([]));
        dispatch(addApplicationMessages('error', [error.responseText]));
    } finally {
        dispatch(setSentTasksFetching(false));
    }
};

const setSentTasks = sentTasks => ({
    type: ACTIONS.SET_SENT_TASKS,
    payload: sentTasks
});

const setSentTasksCount = sentTasksCount => ({
    type: ACTIONS.SET_SENT_TASKS_COUNT,
    payload: sentTasksCount
});

const setSentTasksStudyBinderNames = sentTasksStudyBinderNames => ({
    type: ACTIONS.SET_SENT_TASKS_STUDY_BINDER_NAMES,
    payload: sentTasksStudyBinderNames
});

const setSentTasksFetching = isFetching => ({
    type: ACTIONS.SET_SENT_TASKS_FETCHING,
    payload: isFetching
});

export default fetchSentTasksByStatus;